import { type ProjectCode } from '@constants'
import { type AvailableCoupon } from '@hooks-api/types/dataModel/coupon'

/**
 * Parse availableCoupons to giveawayProductIds
 */
export const parseAvailableCouponCriterionGiveawayProducts = (availableCoupons?: AvailableCoupon[]): {
  project_code: ProjectCode
  id: number
}[] => availableCoupons?.flatMap(coupon =>
  coupon.criterion_groups.flatMap(criterionGroup =>
    criterionGroup.criterions.flatMap(criterion =>
      criterion.giveaways.map(giveaway => ({
        project_code: giveaway.project_code,
        id: giveaway.product_id,
      })),
    ),
  ),
) || []
